<body>
  <div class="container oroDiv">

    <div align="center">
      <header>
        <img src="assets/images/header.png" alt="Logo" title="Official Records Online" />
      </header>
    </div>

    <router-outlet></router-outlet>

    <div align="center">
      <footer>
        <img src="assets/images/Footer.png" alt="Logo" title="Official Records Online Footer" />

        <nav>
          <ul class="oroFooterMenu">
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/contact-us"]' [skipLocationChange]="true" title="Contact Us">Contact Us</a>
            </li>
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/faq"]' [skipLocationChange]="true" title="Frequently asked questions">FAQ</a>
            </li>
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/privacy"]' [skipLocationChange]="true" title="Privacy Policy">Privacy Policy</a>
            </li>
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/refund"]' [skipLocationChange]="true" title="Refund Policy">Refund Policy</a>
            </li>
          </ul>
        </nav>

      </footer>
    </div>

  </div>
</body>